module.exports = __webpack_public_path__ + "media/src/assets/Images/BlackDots-a21078bb803b3acf5f6d9a082c27f1fc.svg";